
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';


@customElement('search-term')
export class SearchTerm extends LitElement {
  @property()
  term: string;

  static styles = css`
:host {
   cursor: pointer;
   font-size: 0.95em;
}
`;

  constructor() {
    super();
    this.term = "";
  }

  search(_ev: Event) {
    // @ts-ignore
    const event = new CustomEvent('set-search', { detail: this.term, bubbles: true, composed: true });
    // @ts-ignore
    this.dispatchEvent(event);
  }
  render() {
    return html`<div @click="${this.search}"><slot @click="${this.search}"></slot></div>`
  }
}

@customElement('drop-down')
export class DropDown extends LitElement {

  static styles = css`
:host {
}
.dropbtn {
  display: block;
  align-self: flex-end;
  color: white;
  background: rgba(0,0,0,0);
  font-size: 1em;
  border: 0px solid fuchsia;
  cursor: pointer;
}

/* Dropdown button on hover & focus */
.dropbtn:hover {
  color: lightblue;
}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  border-radius: 0.3em;
  z-index: 1;
  color: black;
  width: auto;
  max-height: 300px;
  overflow-y: scroll;
}
.dropdown-content a:hover {
  background-color: #ddd;
}
.show {
  display:block;
}
::slotted(search-term) {
   white-space:nowrap;
   display: flex;
   flex-flow: column nowrap;
   color: black;
   justify-content: center;
   padding: 0.6em;
   border-radius: 0.3em;
}
::slotted(search-term:hover) {
   background: #ddd;
}
`;

  getMenu() {
    return this.renderRoot.getElementById("contents");
  }

  myFunction(ev: Event) {
    //console.log("click on menu", this.getMenu().classList.contains('show'));
    if (!this.getMenu().classList.contains('show')) {
      this.getMenu().classList.add("show");
      ev.stopPropagation();
    } else {
      this.getMenu().classList.remove("show");
    }
  }

  otherClick(_ev: Event) {
    this.getMenu().classList.remove("show");
  }

  connectedCallback() {
    super.connectedCallback();
    // @ts-ignore
    window.addEventListener('click', (ev) => { this.otherClick(ev) });
  }

  disconnectedCallback() {
    // @ts-ignore
    window.removeEventListener('click', (ev) => { this.otherClick(ev) });
    super.disconnectedCallback();
  }


  constructor() {
    super();
  }

  render() {
    return html`
<link rel="stylesheet" href="font-awesome-4.7.0/css/font-awesome.min.css">
<div>
<button @click="${this.myFunction}" id="button" class="dropbtn">
<div><slot name="button">Menu</slot> <i class="fa fa-caret-down" aria-hidden="true"></i></div>
</button>
<div id="contents" class="dropdown-content">
<slot></slot>
</div>
</div>`;
  }
}
